// Wave 3B — Commit 3ab
// Type surface for detected_items rows augmented with the offline-shopping
// annotations written by the brand stockist resolver (Commit 2).
//
// This is a lightweight type extension used by the shopping UI components
// (badges, expanded sheets, sort helpers). Full data loading still happens
// via the existing detected_items SELECT * queries in src/routes/index.tsx,
// which pick up these columns for free.

export interface OfflineShoppingStore {
  place_id?: string | null;
  name: string;
  address?: string | null;
  distance_m?: number | null;
  distance_mi?: number | null;
  lat?: number | null;
  lng?: number | null;
  brand?: string | null;
  source?: string | null;
}

export interface OutfitItemOfflineShopping {
  offline_shopping_tier_1: OfflineShoppingStore[] | null;
  offline_shopping_tier_2: OfflineShoppingStore[] | null;
  offline_shopping_source: string | null;
  offline_shopping_brand?: string | null;
  offline_shopping_resolved_at?: string | null;
}

/**
 * Narrow helper: pull the nearest tier_1 store, or fall back to nearest
 * tier_2, or return null. Sorts defensively by distance_m ascending.
 */
export function pickNearestStore(
  item: Partial<OutfitItemOfflineShopping> | null | undefined,
): OfflineShoppingStore | null {
  if (!item) return null;
  const t1 = Array.isArray(item.offline_shopping_tier_1)
    ? item.offline_shopping_tier_1
    : [];
  const t2 = Array.isArray(item.offline_shopping_tier_2)
    ? item.offline_shopping_tier_2
    : [];
  const pool = t1.length > 0 ? t1 : t2;
  if (pool.length === 0) return null;
  const sorted = [...pool].sort(
    (a, b) => (a.distance_m ?? Infinity) - (b.distance_m ?? Infinity),
  );
  return sorted[0] ?? null;
}

export function hasOfflineShoppingData(
  item: Partial<OutfitItemOfflineShopping> | null | undefined,
): boolean {
  if (!item) return false;
  const t1 = Array.isArray(item.offline_shopping_tier_1)
    ? item.offline_shopping_tier_1.length
    : 0;
  const t2 = Array.isArray(item.offline_shopping_tier_2)
    ? item.offline_shopping_tier_2.length
    : 0;
  return t1 + t2 > 0;
}
